namespace GeniuzPOS.InitialData {
    export interface PsCashCouponTypeSerialRow {
        Id?: number;
        CashCouponType?: string;
        Serial?: string;
        CreateBy?: string;
        CreateDate?: string;
        Used?: number;
        IsActive?: number;
    }

    export namespace PsCashCouponTypeSerialRow {
        export const idProperty = 'Id';
        export const nameProperty = 'CashCouponType';
        export const localTextPrefix = 'InitialData.PsCashCouponTypeSerial';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            CashCouponType = "CashCouponType",
            Serial = "Serial",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            Used = "Used",
            IsActive = "IsActive"
        }
    }
}
